import { MCenterModal } from '../Monetize';
import { QuoteAccountHierarchyView } from './QuoteAccountHierarchyView';

interface QuoteAccountHierarchyModalProps {
  accountId: string;
  isOpen?: boolean;
  onClose: () => void;
}

export const QuoteAccountHierarchyModal = ({
  accountId,
  isOpen = true,
  onClose,
}: QuoteAccountHierarchyModalProps) => {
  return (
    <MCenterModal
      size="xl"
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Account Hierarchy"
      modalContentProps={{ 'data-testid': 'account-hierarchy-modal' } as any}
    >
      <QuoteAccountHierarchyView accountId={accountId} />
    </MCenterModal>
  );
};
